import { Navigate, Outlet, useLocation } from "react-router-dom";
import MenuHeader from "./components/Header/MenuHeader";
import { selectUser, updateUser } from "./features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionAlert from "./components/Header/SubscriptionAlert";
import AutoHideAlert from "./components/Alert/Alert";
import { hasAccess } from "./utilities/permissionChecks";
import { useGetUserMutation } from "./features/user/userApiSlice";
import { useEffect } from "react";

const Layout = () => {
  const user = useSelector(selectUser);
  const location = useLocation();
  const [getUser] = useGetUserMutation();
  const dispatch = useDispatch();


  const fetchUser = async () => {
    console.log("fetching user...");
    try {
      const { data } = await getUser().unwrap();

      dispatch(
        updateUser({
          user: data,
        })
      );
    } catch (error) {
      console.error("Failed to fetch user: ", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const authPaths = ["/signup", "/signin", "/", "/google/callback", "/microsoft/callback"];
  const rootPath = "/";

  if (
    (user?.completedOnboarding || user?.step >= 4) &&
    authPaths.includes(location?.pathname)
  ) {
    if (!user?.completedOnboarding) {
      return <Navigate to="/welcome" />;
    }
    return <Navigate to="/home" />;
  } else {
    if (rootPath === location?.pathname) {
      return <Navigate to="/signin" />;
    }
  }

  const modules = user?.modules;
  const permissions = user?.permissions;

  if (!hasAccess(location?.pathname, modules, permissions, user)) {
    console.log("Unauthorized");
    return <Navigate to={`/no-access?noRoleAssigned=${user?.roles?.length === 0 || user?.roles?.[0] === "None"}`} />;
  }

  return (
    <main className="overflow-hidden no-scrollbar">
      {(user?.completedOnboarding || user?.step >= 4) &&
        location?.pathname !== "/welcome" && (
          <>
            {user.subscription !== null &&
              user?.subscription?.status === "trialing" && (
                <SubscriptionAlert />
              )}
            <MenuHeader user={user} />
          </>
        )}
      <AutoHideAlert />
      <Outlet />
    </main>
  );
};

export default Layout;
